const LoadCookieConsentScript = () => {
  const cookieLawLib = document.getElementById('cookieLawLib');
  const cookieLawScript = document.getElementById('cookieLawScript');

  if (!cookieLawLib) {
    const script = document.createElement('script');
    script.src = 'https://cdn.cookielaw.org/consent/325c8a49-ab4c-41ec-8cbb-ee6febb0c28d/OtAutoBlock.js';
    script.id = 'cookieLawLib';
    document.body.appendChild(script);
  }
  if (!cookieLawScript) {
    const script = document.createElement('script');
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.id = 'cookieLawScript';
    script.setAttribute('data-domain-script', '325c8a49-ab4c-41ec-8cbb-ee6febb0c28d');
    document.body.appendChild(script);
  }
  return null;
};

export default LoadCookieConsentScript;



// WEBPACK FOOTER //
// ./js/components/load-cookie-consent/index.jsx